import { Injectable } from "@angular/core";
import { PaymentMasterDataService } from "../data-services/payment-master.data.service";

@Injectable({
    providedIn: 'root'
})

export class PaymentMasterService {
   
    constructor(private service: PaymentMasterDataService) {
    }

    async GetPaymentMethodDropdown(): Promise<any> {
        return this.service.GetPaymentMethodDropdown();
    }
    async GetPaymentTermDropdown(): Promise<any> {
        return this.service.GetPaymentTermDropdown();
    }
    async GetReminderTermDropdown(): Promise<any> {
        return this.service.GetReminderTermDropdown();
    }
    async GetLaborandItemSalesPriceGroup(): Promise<any> {
        return this.service.GetLaborandItemSalesPriceGroup();
    }

    //#endregion
}